var indexOf = [].indexOf;

import featureNames from 'constants/feature_names';

angular.module('gym.components').directive('membershipPlanBuilder', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/membership_plan/membershipPlanBuilder.html.slim'),
    scope: {
      newMembershipPlan: '=',
      membershipPlanCategories: '=',
      eventTypes: '=',
      gradingStyles: '='
    },
    controller: ["$scope", "$rootScope", "$modal", "$filter", "$http", "$timeout", "MembershipIntervalUnits", "EventService", "MembershipPlanService", "Months", function($scope, $rootScope, $modal, $filter, $http, $timeout, MembershipIntervalUnits, EventService, MembershipPlanService, Months) {
      var addEmptyCategory, base, base1, base10, base11, base2, base3, base4, base5, base6, base7, base8, base9, getTotalToCollect, gymDetail, paymentsRelatedKeys, policyKeys, ref, ref1, reloadEventTypes, updateDefaultRepeatDateStrategy, watchMembershipTotal;
      $scope.gym = $rootScope.gym;
      $scope.currency_symbol = $rootScope.gym.currency_symbol;
      $scope.membershipPlan = $scope.newMembershipPlan || {};
      $scope.isMartialArts = $rootScope.gym.is_martial_arts;
      $scope.membershipPlan.cc_invoice_receipt_enabled = !!$scope.membershipPlan.cc_invoice_receipts_to;
      $scope.months = [['', 'Any month']].concat(Months);
      $scope.days = (function() {
        var results = [];
        for (var i = 1; i <= 31; i++){ results.push(i); }
        return results;
      }).apply(this);
      $scope.archiveMembershipPurchaseOptions = [[false, 'does'], [true, 'does not']];
      $scope.automaticRescheduleLimits = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      $scope.mobileAppEnabled = $scope.gym.mobile_app_enabled;
      $scope.featureNames = featureNames;
      policyKeys = ['mobile_app_cancellation_notice_period_unit', 'mobile_app_cancellation_notice_period_number', 'mobile_app_cancel_fee_default_due_date_multiplier', 'mobile_app_cancel_fee_default_due_date_unit', 'mobile_app_cancel_fee_default_due_date_anchor', 'mobile_app_cancellation_minimum_term_number', 'mobile_app_cancellation_minimum_term_unit', 'fee_for_mobile_app_cancellations', 'allow_cancellation_requests_from_mobile_app', 'mobile_app_cancellation_requests_require_review', 'allow_cancellation_requests_from_mobile_app_outside_of_policy', 'mobile_app_cancel_fee_default_due_date_strategy', 'mobile_app_cancel_fee_default_due_date_number', 'mobile_app_cancellation_payments_policy'];
      gymDetail = ((ref = $scope.gym) != null ? ref.gym_membership_detail : void 0) || {};
      _.each(policyKeys, function(key) {
        if ((gymDetail[key] != null) && ($scope.membershipPlan[key] === null || typeof $scope.membershipPlan[key] === 'undefined')) {
          return $scope.membershipPlan[key] = gymDetail[key];
        }
      });
      $scope.extendCancellationPolicyConfig = function(detail) {
        return angular.extend($scope.membershipPlan, detail);
      };
      if (!$scope.membershipPlan.default_start_date_strategy) {
        $scope.membershipPlan.default_start_date_strategy = 'start_on_purchase_date';
      }
      if (!$scope.membershipPlan.member_portal_start_date_limit_unit) {
        $scope.membershipPlan.member_portal_start_date_limit_unit = 'days';
      }
      if (!$scope.membershipPlan.waiver_start_date_limit_unit) {
        $scope.membershipPlan.waiver_start_date_limit_unit = 'days';
      }
      (base = $scope.membershipPlan).default_upfront_date_strategy || (base.default_upfront_date_strategy = 'charge_upfront_amount_on_start_date');
      (base1 = $scope.membershipPlan).default_repeat_date_strategy || (base1.default_repeat_date_strategy = 'start_repeat_payments_one_period_after_upfront');
      (base2 = $scope.membershipPlan).relative_upfront_date_number || (base2.relative_upfront_date_number = $scope.membershipPlan.charge_interval_number || 1);
      (base3 = $scope.membershipPlan).relative_upfront_date_unit || (base3.relative_upfront_date_unit = $scope.membershipPlan.charge_interval_unit || 'weeks');
      (base4 = $scope.membershipPlan).relative_upfront_date_direction || (base4.relative_upfront_date_direction = 'before');
      (base5 = $scope.membershipPlan).relative_repeat_date_number || (base5.relative_repeat_date_number = $scope.membershipPlan.charge_interval_number || 1);
      (base6 = $scope.membershipPlan).relative_repeat_date_unit || (base6.relative_repeat_date_unit = $scope.membershipPlan.charge_interval_unit || 'weeks');
      (base7 = $scope.membershipPlan).relative_start_date_number || (base7.relative_start_date_number = 1);
      (base8 = $scope.membershipPlan).relative_start_date_unit || (base8.relative_start_date_unit = 'weeks');
      (base9 = $scope.membershipPlan).future_booking_term_unit || (base9.future_booking_term_unit = 'weeks');
      (base10 = $scope.membershipPlan).include_archived_memberships_in_purchase_count || (base10.include_archived_memberships_in_purchase_count = false);
      (base11 = $scope.membershipPlan).start_on_next_upcoming_day || (base11.start_on_next_upcoming_day = 1);
      if (!$scope.membershipPlan.id && $scope.gym.gym_config.recurring_bookings_feature_enabled) {
        $scope.membershipPlan.allow_recurring_bookings = true;
      }
      $scope.minSpecifiedStartDate = moment($scope.gym.today).add(1, 'days').toDate();
      $scope.advancedOptionsOpen = !!$scope.membershipPlan.id;
      if (!$scope.membershipPlan.category) {
        $scope.membershipPlan.category = {
          id: null
        };
      }
      addEmptyCategory = function() {
        if (!_.find($scope.membershipPlanCategories, function(category) {
          return !category.id;
        })) {
          return $scope.membershipPlanCategories.unshift({
            id: null,
            label: 'No category'
          });
        }
      };
      if ((ref1 = $scope.membershipPlanCategories) != null ? ref1.reload : void 0) {
        $scope.membershipPlanCategories.reload().then(function() {
          return addEmptyCategory();
        });
      } else {
        addEmptyCategory();
      }
      $scope.$on('membershipPlanCategories:changed', function() {
        var ref2;
        if ((ref2 = $scope.membershipPlanCategories) != null ? ref2.reload : void 0) {
          return $scope.membershipPlanCategories.reload().then(function() {
            return addEmptyCategory();
          });
        }
      });
      $scope.toggleAdvancedOptions = function() {
        return $scope.advancedOptionsOpen = !$scope.advancedOptionsOpen;
      };
      $scope.isTypeSelected = function(id) {
        return indexOf.call($scope.membershipPlan.event_type_ids, id) >= 0;
      };
      $scope.isStyleSelected = function(id) {
        return indexOf.call($scope.membershipPlan.style_ids, id) >= 0;
      };
      $scope.recurringBookingsDisabled = function() {
        return !$scope.membershipPlan.classes_unlimited && !$scope.membershipPlan.classes_interval_number;
      };
      updateDefaultRepeatDateStrategy = function() {
        var isStartRepeatPaymentOnStartDate, plan;
        plan = $scope.membershipPlan;
        isStartRepeatPaymentOnStartDate = plan.default_repeat_date_strategy === 'start_repeat_payments_on_membership_start_date';
        if (!$scope.isUpfrontAndRecurring() && plan.default_repeat_date_strategy === 'start_repeat_payments_one_period_after_upfront') {
          plan.default_repeat_date_strategy = 'start_repeat_payments_on_membership_start_date';
        }
        if (($scope.isUpfrontAndRecurring() && !$scope.selectedDefaultRepeatDateStrategy) || ($scope.membershipStartDateRepeatDateStrategyUnavailable() && isStartRepeatPaymentOnStartDate)) {
          return plan.default_repeat_date_strategy = 'start_repeat_payments_one_period_after_upfront';
        }
      };
      $scope.onPlanTypeChange = function() {
        if ($scope.membershipPlan.plan_type === 'upfront') {
          $scope.tempCostRepeat = $scope.membershipPlan.cost_repeat;
          return $scope.membershipPlan.cost_repeat = 0;
        } else {
          $scope.membershipPlan.cost_repeat = $scope.tempCostRepeat;
          return updateDefaultRepeatDateStrategy();
        }
      };
      $scope.isFree = function() {
        return !parseFloat($scope.membershipPlan.cost_upfront) && !parseFloat($scope.membershipPlan.cost_repeat);
      };
      $scope.isUpfront = function() {
        return parseFloat($scope.membershipPlan.cost_upfront) > 0 && !parseFloat($scope.membershipPlan.cost_repeat);
      };
      $scope.isRecurring = function() {
        return parseFloat($scope.membershipPlan.cost_repeat) > 0 && !parseFloat($scope.membershipPlan.cost_upfront);
      };
      $scope.isUpfrontAndRecurring = function() {
        return parseFloat($scope.membershipPlan.cost_upfront) > 0 && parseFloat($scope.membershipPlan.cost_repeat) > 0;
      };
      $scope.toggleType = function(id) {
        if ($scope.isTypeSelected(id)) {
          return $scope.membershipPlan.event_type_ids = _.without($scope.membershipPlan.event_type_ids, id);
        } else {
          return $scope.membershipPlan.event_type_ids.push(id);
        }
      };
      $scope.toggleStyle = function(id) {
        if ($scope.isStyleSelected(id)) {
          return $scope.membershipPlan.style_ids = _.without($scope.membershipPlan.style_ids, id);
        } else {
          return $scope.membershipPlan.style_ids.push(id);
        }
      };
      reloadEventTypes = function() {
        return EventService.eventTypesWithDeleted($scope.membershipPlan.event_type_ids).then(function(types) {
          return $scope.eventTypes = types;
        });
      };
      $scope.manageTypes = function() {
        var roomModal;
        roomModal = $modal.open({
          template: require('templates/gyms/calendar/events/manage_types.html.slim'),
          controller: 'ManageEventTypesModal',
          resolve: {
            types: function() {
              return $scope.eventTypes;
            }
          }
        });
        return roomModal.result.then(function() {
          return reloadEventTypes();
        }, function() {
          return reloadEventTypes();
        });
      };
      $scope.onClassesUnlimitedToggle = function() {
        var base12;
        if ($scope.membershipPlan.classes_unlimited) {
          return (base12 = $scope.membershipPlan).future_booking_term_unit || (base12.future_booking_term_unit = 'weeks');
        } else {
          $scope.membershipPlan.restrict_future_bookings_by_count = false;
          $scope.membershipPlan.restrict_future_bookings_by_date = false;
          $scope.membershipPlan.future_bookings_count_limit = null;
          $scope.membershipPlan.future_booking_term_number = null;
          $scope.membershipPlan.future_booking_term_unit = null;
          return $scope.membershipPlan.allow_recurring_bookings = false;
        }
      };
      $scope.displayFutureBookingLimitsDescription = function(event, type) {
        event.preventDefault();
        return $modal.open({
          template: require('templates/components/membership_plan/future_booking_limits.html.slim'),
          controller: 'FutureBookingLimitsModal',
          resolve: {
            type: function() {
              return type;
            }
          }
        });
      };
      $scope.displayRecurringBookingsDescription = function(event) {
        event.preventDefault();
        return EventService.displayRecurringBookingsDescription();
      };
      $scope.displayTrialMembershipDescription = function(event) {
        event.preventDefault();
        return MembershipPlanService.displayTrialMembershipDescription($scope.featureNames);
      };
      $scope.membershipPlan.not_classes_interval = !(($scope.membershipPlan.classes_interval_number != null) && $scope.membershipPlan.classes_interval_number > 0);
      $scope.$watch('membershipPlan.not_classes_interval', function(newVal) {
        if (newVal) {
          $scope.membershipPlan.classes_interval_number = 0;
        }
        if (newVal && $scope.recurringBookingsDisabled()) {
          return $scope.membershipPlan.allow_recurring_bookings = false;
        }
      });
      $scope.daysWeeksMonthsYearsOptions = _.pairs(MembershipIntervalUnits);
      $scope.daysWeeksMonthsOptions = _.pairs(_.omit(MembershipIntervalUnits, 'years'));
      $scope.onSendInvoiceReceiptChanged = function() {
        $scope.membershipPlan.tax_status = '';
        if (!$scope.membershipPlan.send_invoice_receipts) {
          $scope.membershipPlan.cc_invoice_receipt_enabled = false;
          return $scope.membershipPlan.cc_invoice_receipts_to = '';
        }
      };
      $scope.onCcInvoiceReceiptToggleChanged = function() {
        if (!$scope.membershipPlan.cc_invoice_receipt_enabled) {
          return $scope.membershipPlan.cc_invoice_receipts_to = '';
        }
      };
      $scope.onAutomaticRescheduleToggle = function() {
        if ($scope.membershipPlan.perform_automatic_reschedule) {
          $scope.membershipPlan.automatic_reschedule_days = 1;
          return $scope.membershipPlan.automatic_reschedule_limit = 3;
        } else {
          $scope.membershipPlan.automatic_reschedule_days = 0;
          return $scope.membershipPlan.automatic_reschedule_limit = 0;
        }
      };
      $scope.openMembershipPlanCategoryManagement = function() {
        return $modal.open({
          template: require('templates/gyms/membership_plans/membershipPlanCategoryManagement.html.slim'),
          controller: 'MembershipPlanCategoryManagementCtrl'
        });
      };
      $scope.onSpecifiedStartDateSelect = function() {
        return $scope.membershipPlan.default_start_date_strategy = 'start_on_specific_date';
      };
      $scope.onUpfrontCostChange = function() {
        var plan;
        plan = $scope.membershipPlan;
        if (!$scope.isUpfrontAndRecurring() && plan.default_repeat_date_strategy === 'start_repeat_payments_one_period_after_upfront') {
          plan.default_repeat_date_strategy = 'start_repeat_payments_on_membership_start_date';
        }
        return updateDefaultRepeatDateStrategy();
      };
      $scope.onCostRepeatChange = function() {
        return updateDefaultRepeatDateStrategy();
      };
      $scope.onDefaultRepeatDateStrategyChange = function() {
        return $scope.selectedDefaultRepeatDateStrategy = $scope.membershipPlan.default_repeat_date_strategy;
      };
      $scope.onDefaultStartDateStrategyChange = function() {
        $scope.membershipPlan.specified_start_date = void 0;
        $scope.membershipPlan.allow_customer_to_choose_start_date_on_member_portal = false;
        $scope.membershipPlan.allow_customer_to_choose_start_date_on_waiver = false;
        if ($scope.membershipPlan.default_start_date_strategy === 'start_on_purchase_date') {
          return $scope.membershipPlan.default_upfront_date_strategy = 'charge_upfront_amount_on_start_date';
        }
      };
      $scope.onDefaultUpfrontStrategyChange = function() {
        if ($scope.isUpfrontAndRecurring()) {
          return $scope.membershipPlan.default_repeat_date_strategy = 'start_repeat_payments_on_membership_start_date';
        }
      };
      $scope.onlyOnMembershipStartDateUpfronttDateStrategyAvailable = function() {
        var plan;
        plan = $scope.membershipPlan;
        return ($scope.isUpfront() || $scope.isUpfrontAndRecurring()) && plan.default_start_date_strategy === 'start_on_purchase_date';
      };
      $scope.onlyOnMembershipStartDateRepeatDateStrategyAvailable = function() {
        var plan, ref2;
        plan = $scope.membershipPlan;
        return $scope.isUpfrontAndRecurring() && ((ref2 = plan.default_upfront_date_strategy) === 'charge_upfront_amount_relative_to_start_date' || ref2 === 'charge_upfront_amount_asap');
      };
      $scope.membershipStartDateRepeatDateStrategyUnavailable = function() {
        var plan;
        plan = $scope.membershipPlan;
        return $scope.isUpfrontAndRecurring() && plan.default_start_date_strategy === 'start_on_purchase_date';
      };
      $scope.getUpfrontStrategy = function() {
        var num, period, unit;
        switch ($scope.membershipPlan.default_upfront_date_strategy) {
          case 'charge_upfront_amount_on_start_date':
            return 'when the membership starts';
          case 'charge_upfront_amount_relative_to_start_date':
            unit = $scope.membershipPlan.relative_upfront_date_unit;
            num = $scope.membershipPlan.relative_upfront_date_number;
            period = $filter('pluralize')(unit, num, true);
            return `${period} before the membership starts, or immediately if that date has passed`;
          case 'charge_upfront_amount_asap':
            return 'as soon as possible';
        }
      };
      $scope.getFrequency = function() {
        var number, period, unit;
        number = $scope.membershipPlan.charge_interval_number;
        unit = $scope.membershipPlan.charge_interval_unit;
        period = $filter('pluralize')(unit, number, number > 1);
        return `every ${period}`;
      };
      $scope.getRepeatStrategy = function() {
        var date, number, period, plan, unit;
        plan = $scope.membershipPlan;
        switch (plan.default_repeat_date_strategy) {
          case 'start_repeat_payments_one_period_after_upfront':
            number = plan.charge_interval_number;
            unit = plan.charge_interval_unit;
            period = $filter('pluralize')(unit, number, true);
            return `${period} after initial payment`;
          case 'start_repeat_payments_on_membership_start_date':
            return "when the membership starts";
          case 'start_repeat_payments_relative_to_start_or_upfront':
            number = plan.relative_repeat_date_number;
            unit = plan.relative_repeat_date_unit;
            period = $filter('pluralize')(unit, number, true);
            date = parseFloat(plan.cost_upfront) > 0 ? "initial payment" : "membership starts";
            return `${period} after ${date}`;
        }
      };
      $scope.getExpiry = function() {
        var number, period, unit;
        if (!($scope.membershipPlan.term_number > 0)) {
          return 'indefinitely';
        }
        number = $scope.membershipPlan.term_number;
        unit = $scope.membershipPlan.term_unit;
        period = $filter('pluralize')(unit, number, true);
        return `for ${period}`;
      };
      paymentsRelatedKeys = ['cost_upfront', 'cost_repeat', 'charge_interval_unit', 'charge_interval_number', 'term_unit', 'term_number', 'default_start_date_strategy', 'default_upfront_date_strategy', 'default_repeat_date_strategy', 'specified_start_date', 'relative_start_date_number', 'relative_start_date_unit', 'relative_upfront_date_number', 'relative_upfront_date_unit', 'relative_repeat_date_number', 'relative_repeat_date_unit', 'start_on_next_upcoming_day', 'start_on_next_upcoming_month'];
      getTotalToCollect = _.memoize(function(plan) {
        var hasRepeatPayment, hasUpfrontPayment, params, url;
        hasUpfrontPayment = parseFloat(plan.cost_upfront) > 0;
        hasRepeatPayment = parseFloat(plan.cost_repeat) > 0;
        if (!hasUpfrontPayment && !hasRepeatPayment) {
          return 0;
        }
        if (hasUpfrontPayment && !hasRepeatPayment) {
          return parseFloat(plan.cost_upfront);
        }
        if (hasRepeatPayment && !(plan.term_number > 0) || !(plan.charge_interval_number > 0)) {
          return 'N/A';
        }
        url = `/gyms/${$scope.gym.id}/membership_plans/estimate_total_to_collect`;
        params = {
          membership_plan: _.pick($scope.membershipPlan, paymentsRelatedKeys)
        };
        return $http.post(url, params);
      }, function() {
        var plan, values;
        plan = $scope.membershipPlan;
        values = paymentsRelatedKeys.map(function(key) {
          return $scope.membershipPlan[key];
        });
        return values.join('_');
      });
      watchMembershipTotal = _.debounce(function(plan, oldPlan) {
        return $timeout(function() {
          var total;
          total = getTotalToCollect(plan);
          if (total.then) {
            return total.then(function(response) {
              return $scope.totalToCollect = $filter('currency')(response.data.value, $scope.currency_symbol);
            });
          } else {
            if (total > 0) {
              return $scope.totalToCollect = $filter('currency')(total, $scope.currency_symbol);
            } else {
              return $scope.totalToCollect = total;
            }
          }
        });
      }, 1500);
      return $scope.$watch('membershipPlan', watchMembershipTotal, true);
    }]
  };
});
